<form [formGroup]="pricingForm" (ngSubmit)="save()" style="max-width:400px;padding:24px;">
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="dutyAmount" placeholder="DUTY">
    <mat-hint>Flat fee added to Custom when duty is selected on an order</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="nosepadsInstallAmount" placeholder="NOSEPADS INSTALL">
    <mat-hint>Flat fee added to Custom when nosepads install is selected on an order</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="drillMountAmount" placeholder="DRILL MOUNT">
    <mat-hint>Flat fee added to Custom when drill mount is selected on an order</mat-hint>
  </mat-form-field>
  <button mat-raised-button type="submit" [disabled]="pricingForm.invalid || saving">SAVE</button>
</form>
